import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { catchError, throwError } from 'rxjs';
import { WorkspaceService } from '@sentry/forms-core';

/**
 * Catches 401 responses from the API (expired or invalid token) and immediately
 * clears the local session before redirecting the user to the Auth0 login page.
 * This prevents the app from getting stuck in an infinite loading state when
 * the Auth0 session expires after 24 hours.
 */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const workspaceService = inject(WorkspaceService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === HttpStatusCode.Unauthorized) {
        const workspaceId = workspaceService.activeWorkspace()?.id ?? null;
        workspaceService.clearSession();
        authService.loginWithRedirect({ appState: { target: window.location.pathname, workspaceId } });
      }
      return throwError(() => error);
    }),
  );
};
